import PropTypes from 'prop-types';
import { combineReducers } from 'redux';
import { createSingleDataReducer, singleDataType } from '../factories/ApiCall';
import type {
  LostPasswordAction,
  LostPasswordState,
  PasswordActionResponse,
  ResetPasswordParams,
  SendResetPasswordLinkParams,
} from '../types/LostPassword';

/*
 * action types
 */

const types = {
  GET_USERS: 'USER/GET_USERS',
  SAVE_USERS: 'USER/SAVE_USERS',
  ADD_USER: 'USER/ADD_USER',
  REMOVE_USER: 'USER/REMOVE_USER',
  UPDATE_USER: 'USER/UPDATE_USER',
  RESET_PASSWORD: 'USER/RESET_PASSWORD',
  SEND_PSW_RESET_LINK: 'USER/SEND_PSW_RESET_LINK',
  GET_PRIVILEGES: 'USER/GET_PRIVILEGES',
} as const;

/*
 * action creators
 */

const actions = {
  resetPassword: (
    code: string,
    password: string
  ): LostPasswordAction<ResetPasswordParams> => ({
    type: types.RESET_PASSWORD,
    payload: { code, password },
  }),
  sendPasswordResetLink: (
    username: string,
    server_url?: string
  ): LostPasswordAction<SendResetPasswordLinkParams> => ({
    type: types.SEND_PSW_RESET_LINK,
    payload: { username, server_url },
  }),
};

/*
 * state shape
 */
const propType = PropTypes.shape({
  resetPassword: singleDataType,
  sendPasswordResetLink: singleDataType,
});

/*
 * reducer
 */
const reducer = combineReducers({
  resetPassword: createSingleDataReducer<
    PasswordActionResponse,
    ResetPasswordParams
  >(types.RESET_PASSWORD),
  sendPasswordResetLink: createSingleDataReducer<
    PasswordActionResponse,
    SendResetPasswordLinkParams
  >(types.SEND_PSW_RESET_LINK),
}) as (
  state: LostPasswordState | undefined,
  action: LostPasswordAction
) => LostPasswordState;

export { types as actionTypes, actions as default, propType, reducer };
